import { Container } from './styles'

export const DoGoodDay = () => {

  return (
    <Container.box id="doGoodDay">
      {/* <Container.content >
        <Container.title>
          <h2>
            A Fábrica <span>Criativa</span>
          </h2>
        </Container.title>
        <p>A Fábrica Criativa escolheu a Gooders porque acredita e investe em causas sociais, alinhando-se à nossa missão e aos Objetivos de Desenvolvimento Sustentável (ODS), especialmente:

          <br></br>
          <br></br>

          •	ODS 4 (Educação de Qualidade, pela formação e capacitação).<br></br>
          •	ODS 8 (Trabalho decente e crescimento econômico, pela profissionalização da cadeia criativa).<br></br>
          •	ODS 9 (Indústria, inovação e infraestrutura, via fomento à economia criativa).<br></br>
          •	ODS 10 (Redução das desigualdades, ao ampliar acesso a serviços profissionais).<br></br>
          •	ODS 11 (Cidades e comunidades sustentáveis, fortalecendo a cena local).<br></br>

          <br></br>
          Em resumo, acesso + qualidade + prestação de contas para transformar talento em carreira e carreira em impacto.
        </p>
      </Container.content> */}
    </Container.box>
  )
}
